import { useMerchant } from "@/hooks/useMerchant";
import { useTopUpsEnabled } from "./useTopUpsEnabled";

// top ups already paid GMF when the merchant loaded them
export function useShowGmf(): boolean {
  const { merchant } = useMerchant();
  const isTopUpsEnabled = useTopUpsEnabled();
  return (
    !!merchant?.payoutsConfig?.buildingManagementEnabled && !isTopUpsEnabled
  );
}
